
import {defineComponent} from "@vue/runtime-core";

export default defineComponent({
  props: {
    is: {
      type: String,
      default: () => "div",
    },
    layer: {
      type: Number,
      default: () => 1,
    },
  },
  computed: {},
});
